import { x } from '@xstyled/styled-components';
import React, { useState } from 'react';
import { t } from 'ttag';
import { usePostCommentMutation } from '~/data';
import { Button } from '~/ui/buttons';
import { Spinner } from '~/ui/spinner/Spinner';
import { Sequence, useTrainingStore } from '../../state';
import { useTrainingParams } from '../../useTrainingParams';
import { getUA } from 'react-device-detect';
import { ThumbsPages, useThumbsStore } from '../Store';

interface Props {
  topic: string;
  label: string;
}

export const IssueForm = ({ topic, label }: Props) => {
  const [question, setQuestion] = useState('');
  const { learnerTrainingId, sequenceId } = useTrainingParams();
  const items = useTrainingStore(s => s.items);
  const { setPage } = useThumbsStore();
  const [postComment, { loading, data, error }] = usePostCommentMutation();

  const handleSubmit = () => {
    const sequence = items.find(
      i => i.kind === 'sequence' && i.id === sequenceId
    ) as Sequence;
    postComment({
      variables: {
        learnerTrainingUuid: learnerTrainingId!,
        question: question,
        recipient: 'easyllama',
        chapterSequenceId: sequence.chapterSequenceId,
        topic,
        userAgent: getUA
      }
    }).then(() => {
      if (!error || !data?.comment?.errors.length) {
        setPage(ThumbsPages.ThankScreen);
      }
    });
  };

  if (loading)
    return (
      <x.div w={{ _: '100%', md: '270px' }}>
        <Spinner backgroundColor="transparent" />
      </x.div>
    );

  if (error || data?.comment?.errors.length) {
    return (
      <x.div
        maxWidth={{ _: '100%', md: '270px' }}
        textAlign="center"
        aria-live="assertive"
        fontSize="18px"
      >
        {t`We're sorry, an unexpected error has occurred`}
      </x.div>
    );
  }

  return (
    <x.form
      w={{ _: '100%', md: '280px' }}
      display="flex"
      flexDirection="column"
      alignItems="center"
      gap="md"
    >
      <x.label
        p="3px 25px"
        fontSize="18px"
        textAlign="center"
        htmlFor="writeYourMessage"
        fontWeight="bold"
      >
        {label}
      </x.label>
      <x.textarea
        id="writeYourMessage"
        background="transparent"
        border="1px solid gray"
        placeholder="Type your message here"
        className="textareaStyleForDarTheme"
        onChange={e => setQuestion(e.target.value)}
        h="130px"
        w="100%"
        p="sm"
        resize="none"
      />
      <Button w="100%" onClick={handleSubmit}>
        {t`Submit`}
      </Button>
    </x.form>
  );
};
